import { render, staticRenderFns } from "./DetectionForm.vue?vue&type=template&id=0cd97801&scoped=true&"
import script from "./DetectionForm.vue?vue&type=script&lang=js&"
export * from "./DetectionForm.vue?vue&type=script&lang=js&"
import style0 from "./DetectionForm.vue?vue&type=style&index=0&id=0cd97801&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd97801",
  null
  
)

export default component.exports